import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { keyframes } from 'styled-components';

interface LoadingSpinnerProps {
  size?: number;
  centered?: boolean;
  color?: string;
}

export const LoadingSpinner = ({
  size = 14,
  centered = false,
  color,
}: LoadingSpinnerProps) => {
  if (centered) {
    return (
      <CenteredWrapper>
        <SpinnerIcon icon={faSpinner} $size={size} $color={color} />
      </CenteredWrapper>
    );
  }

  return <SpinnerIcon icon={faSpinner} $size={size} />;
};

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SpinnerIcon = styled(FontAwesomeIcon)<{ $size: number; $color?: string }>`
  animation: ${spin} 1s linear infinite;
  color: ${(props) => props.$color || 'inherit'};
  font-size: ${(props) => props.$size}px;
`;

const CenteredWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 20px;
`;
